import { render, staticRenderFns } from "./ChangeCategoryModal.vue?vue&type=template&id=94ed6afa&"
import script from "./ChangeCategoryModal.vue?vue&type=script&lang=js&"
export * from "./ChangeCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports